<div nz-row nzJustify="end">
    <div nz-col>
      <table>
        <tbody>  
          <ng-container>
            <tr>
              <td>
                <span class="total-amount total-amount-title left-align">Total</span>
              </td>
              <td class="amount-label">
                <span class="total-amount">{{ totalAmount | number: '0.2' }}</span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
</div>
  